export default __webpack_public_path__ + "static/media/c2.57aa63ee.svg";